import React from "react";
import { FormDeduction } from "./FormDeduction";
import { IDeduction } from "../models/IDeduction";

interface Props {
  onClose: () => void;
  deduction?: Partial<IDeduction> & Record<string, any>;
  onSubmit?: (values: Record<string, string>) => void;
}

export const ModalDeduction = ({ onClose, deduction, onSubmit }: Props) => {
  return (
    <FormDeduction
      onClose={onClose}
      initialValues={deduction}
      onSubmit={onSubmit}
    />
  );
};
